// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1U0el","inner":"Footer_inner__3dhDT","nextIcon":"Footer_nextIcon__18yu9","innerLeft":"Footer_innerLeft__1Xx4-"};